module.exports = __webpack_public_path__ + "img/kefu1.bda643ef.webp";